<div class="modal-header">
  <h5 class="modal-title" id="holdModalLabel"><i class="fas fa-hand-holding"></i> Giữ Sách</h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Đóng">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Nội Dung Modal -->
<div class="modal-body">
  <form [formGroup]="holdForm" style="background-color: white; padding: 20px; border-radius: 5px;">
    
    <!-- Mã Vạch Sách -->
    <div class="form-group">
      <label for="itemBarcode">Mã Vạch Sách:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn mã vạch của sách bạn muốn giữ."></i>
      <ng-select  id="itemBarcode" name="itemBarcode"
                 [items]="books$"
                 bindLabel="title" bindValue="id"
                 formControlName="itemBarcode"
                 placeholder="Chọn mã vạch"
                 [loading]="loading">
      </ng-select>
    </div>

    <!-- Tên Thành Viên -->
    <div class="form-group">
      <label for="memberName">Tên Thành Viên:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn tên của thành viên giữ sách."></i>
      <ng-select  id="memberName" name="memberName" 
                 [items]="members$"
                 bindLabel="firstname" bindValue="id"
                 formControlName="memberName"
                 placeholder="Chọn thành viên">
      </ng-select>
    </div>

  </form>
</div>

<!-- Chân Modal -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Đóng</button>
  <button type="button" class="btn btn-outline-primary" (click)="hold()">Giữ</button>
</div>

